import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppointmentsService } from '../../../../services/appointments/appointments.service';
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTabsModule } from '@angular/material/tabs';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { KeyValuePair } from 'allai-admin-shared';
import { Router } from '@angular/router';

/** The appointment detail page */
@Component({
	selector: 'app-appointment-detail',
	imports: [
		MatIconModule,
		MatButtonModule,
		MatTabsModule,
		MatTableModule
	],
	providers: [provideNativeDateAdapter()],
	templateUrl: './appointment-detail.component.html',
	styleUrl: './appointment-detail.component.scss'
})
export class AppointmentDetailComponent implements OnInit, OnDestroy {
	appointmentDataSource: MatTableDataSource<KeyValuePair>;
	readonly displayedColumns: (keyof KeyValuePair)[] = ['key', 'value'];

	constructor(private appointmentsService: AppointmentsService, private router: Router) {

	}

	ngOnInit() {
		this.refresh();

	}
	private refresh() {
		let appointmentDetail = this.appointmentsService.appointmentDetail;
		let data: KeyValuePair[] = [];
		if (appointmentDetail) {
			data = [
				{ key: "Appointment", value: appointmentDetail.appointment.id },
				{ key: "Date", value: appointmentDetail.appointment.appointment_date },
				{ key: "Type", value: appointmentDetail.appointment.ehr_appointment_type_name },
				{ key: "Status", value: appointmentDetail.appointment.status },
				{ key: "Survey", value: `${appointmentDetail.appointment.id_patient_survey_link} - ${appointmentDetail.survey?.status ?? 'NOT_STARTED'}` },
				{ key: "Patient", value: `${appointmentDetail.appointment.id_patient} - ${appointmentDetail.patient.mrn} - ${appointmentDetail.patient.first_name} ${appointmentDetail.patient.last_name}`, link:{path: "patients", id: appointmentDetail.patient.id} },
				{ key: "Provider", value: `${appointmentDetail.appointment.id_provider} - ${appointmentDetail.provider.first_name} ${appointmentDetail.provider.last_name}`,link:{path: "users", id: appointmentDetail.appointment.id_provider} },
				{ key: "Organization", value: `${appointmentDetail.organization.id} - ${appointmentDetail.organization.name}`, link:{path: "organizations", id: appointmentDetail.organization.id} },
				{ key: "User Agent", value: appointmentDetail.userAgent}
			]
		}
		this.appointmentDataSource = new MatTableDataSource<KeyValuePair>(data);
	}

	ngOnDestroy() {
	}

	gotoRow(row: KeyValuePair) {
		if(row.link) {
				let url = this.router.serializeUrl(this.router.createUrlTree(['/', row.link.path, row.link.id]));
				window.open(url, `_${row.link.path}_${row.link.id}`);

		}
	}
}
